import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import type { ITheme } from '@inter-ikea-kompis/types';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import { Icon } from '@inter-ikea-kompis/component-icon';
import { Text } from '@inter-ikea-kompis/component-text';

import type StatusIndicatorColorEnum from '../../enums/StatusIndicatorColorEnum.js';
import StatusIndicatorDotPositionEnum from '../../enums/StatusIndicatorDotPositionEnum.js';
import StatusIndicatorFontSizeEnum from '../../enums/StatusIndicatorFontSizeEnum.js';
import StatusIndicatorStyle from './StatusIndicatorStyle.js';

/**
 * @deprecated This component has been deprecated, see Kompis page for more info.
 */

export default class StatusIndicator extends KompisElement {
	// Status label text
	@property({ type: String })
	public statusLabel: string | null = null;

	// Status indicator dot color
	@property({ type: String })
	public statusColor: StatusIndicatorColorEnum | null = null;

	// Where the indicator should be.
	@property({ type: String })
	public statusDotPosition: StatusIndicatorDotPositionEnum = StatusIndicatorDotPositionEnum.leading;

	// Font size.
	@property({ type: String })
	public size: StatusIndicatorFontSizeEnum = StatusIndicatorFontSizeEnum.medium;

	// Theme
	@property({ type: Object, required: true })
	public theme!: ITheme;

	/**
	 * Renders the component.
	 *
	 * @returns Template.
	 */
	public override render(): RenderResult {
		const small = this.size === StatusIndicatorFontSizeEnum.small;
		return html`
			<style>
				${StatusIndicatorStyle.getStyle({
					theme: this.theme,
					statusDotPosition: this.statusDotPosition,
					small,
					statusColor: this.statusColor
				})}
			</style>

			<div class="container">${this.getCircle()}${this.getLabel()}</div>
		`;
	}

	public override connectedCallback(): void {
		this.customElements.define('kompis-icon', Icon);
		this.customElements.define('kompis-text', Text);

		super.connectedCallback();
	}
	/**
	 * Returns Circle.
	 *
	 * @returns Template.
	 */
	private getCircle(): RenderResult {
		if (!this.statusColor) {
			return null;
		}

		return html`
			<span class="dot">
				<div class="dotFill"></div>
			</span>
		`;
	}

	/**
	 * Returns label.
	 *
	 * @returns Template.
	 */
	private getLabel(): RenderResult {
		if (!this.statusLabel) {
			return null;
		}

		return html`
			<div class="divider"></div>
			<kompis-text
				.theme="${this.theme}"
				.type="${this.size === StatusIndicatorFontSizeEnum.small
					? ThemeFontStyleTypeEnum.bodySmall
					: ThemeFontStyleTypeEnum.bodyMedium}"
			>
				${this.statusLabel}
			</kompis-text>
		`;
	}
}
declare global {
	interface HTMLElementTagNameMap {
		'kompis-status-indicator': StatusIndicator;
	}
}
